import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import { WorkshopList, InfoPage, Layout, Footer, EmailConfirmPage } from './components/';

export default function App() {
  return (
    <Router sx={{
      p: 0,
    }}>
      <Layout />
      <Container maxWidth={false}
        sx={{
          maxWidth: '95%',
          // {
          //   xs: "95%",
          //   sm: "1000px",
          //   md: "1200px",
          //   lg: "1800px"
          // },
          minHeight: '100vh',
        }}>

        <Routes>
          <Route path="/" element={<WorkshopList />} />
          <Route path="/workshops/:documentId" element={<InfoPage />} />
          <Route path="/bookings/verify/:email_token" element={<EmailConfirmPage />} />
        </Routes>
      </Container>
      <Footer />
    </Router>
  );
}